module.exports = __webpack_public_path__ + "static/media/hotelanimation.a04883fb.riv";